<div
    class="recent-activity__container"
    *ngIf="!readOnlyUser"
    [class.recent-activity__container--collapsed]="!isExpanded"
>
    <div class="recent-activity__header">
        <h3 class="recent-activity__title">
            <button
                class="recent-activity__toggle"
                type="button"
                [attr.aria-expanded]="isExpanded"
                [attr.aria-controls]="'recent-activity-content-' + componentId"
                (click)="toggleExpanded(); $event.stopPropagation()"
            >
                <span>Recent Response Activity</span>
                <span nz-icon [nzType]="isExpanded ? 'up' : 'down'" aria-hidden="true"></span>
            </button>
        </h3>
    </div>
    <div
        class="recent-activity__content"
        [class.recent-activity__content--expanded]="isExpanded"
        [attr.aria-hidden]="!isExpanded"
    >
        <div
            class="recent-activity__content-inner"
            [id]="'recent-activity-content-' + componentId"
            [attr.inert]="isExpanded ? null : ''"
        >
            <p class="recent-activity__not-included">Only administrators and assessors assigned to this assessment can see this.<br />This will not be included in the completed report.</p>

            <div class="recent-activity__filters">
                <button
                    *ngIf="!areFiltersVisible; else recentActivityFilters"
                    nz-button
                    nzType="link"
                    nzSize="small"
                    type="button"
                    class="recent-activity__filter-reveal"
                    (click)="showFilters()"
                >
                    <span nz-icon nzType="filter" aria-hidden="true"></span>
                    Filter
                </button>
                <ng-template #recentActivityFilters>
                    <div class="recent-activity__filter-controls">
                        <nz-select
                            [id]="'recent-activity-authors-' + componentId"
                            nzMode="multiple"
                            nzPlaceHolder="Filter by user"
                            aria-label="Filter recent activity by user"
                            [nzAllowClear]="true"
                            [ngModel]="selectedAuthorNames"
                            (ngModelChange)="onAuthorFilterChange($event)"
                        >
                            <nz-option *ngFor="let author of authorOptions" [nzValue]="author" [nzLabel]="author"></nz-option>
                        </nz-select>
                    </div>
                </ng-template>
            </div>

            <nz-spin [nzSpinning]="isLoading" nzSize="small" class="recent-activity__spinner">
                <div *ngIf="filteredActivities.length > 0; else recentActivityEmpty" class="recent-activity__table">
                    <div
                        *ngFor="let activity of filteredActivities; trackBy: trackById"
                        class="recent-activity__row"
                    >
                        <div class="recent-activity__description">
                            <p class="recent-activity__description-text">{{ activity.userDisplayName }}</p>
                            <span *ngIf="activity.userRole" class="recent-activity__description-role">
                                Assigned as: {{ activity.userRole }}
                            </span>
                        </div>
                        <div class="recent-activity__timestamp">
                            <span class="recent-activity__timestamp-date">
                                {{ activity.createdAt | date: 'd MMM y \' at \' hh:mm' }}
                            </span>
                            <span
                                *ngIf="activity.userDisplayName"
                                class="recent-activity__timestamp-author"
                            >
                                {{ activity.description }}
                            </span>
                            <button
                                *ngIf="aggregateByLicense && getRequirementReferenceLabel(activity.questionReference) as requirementLabel"
                                nz-button
                                nzType="primary"
                                nzSize="small"
                                class="cb4-button appendix-b__requirement-number recent-activity__requirement-link"
                                type="button"
                                [attr.aria-label]="'Go to ' + requirementLabel"
                                (click)="onRequirementReferenceClick(activity.questionReference)"
                            >
                                {{ requirementLabel }}
                            </button>
                        </div>
                    </div>
                </div>
            </nz-spin>

            <ng-template #recentActivityEmpty>
                <div class="recent-activity__empty">
                    {{ activities.length > 0 ? 'No activity on this page matches the selected users.' :
                        (aggregateByLicense && total === 0 ? 'No recent response activity has been recorded for this assessment.' :
                            'No recent activity has been recorded on this page.') }}
                </div>
            </ng-template>

            <nz-pagination
                *ngIf="total > pageSize"
                class="recent-activity__pagination"
                [nzPageIndex]="pageIndex"
                [nzPageSize]="pageSize"
                [nzTotal]="total"
                [nzShowSizeChanger]="false"
                (nzPageIndexChange)="onPageChange($event)"
            ></nz-pagination>
        </div>
    </div>
</div>
